import { lazy } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// project imports
import Loadable from 'components/Loadable';

import { Provider as ApplicationProvider } from 'context/application.context';
import { Provider as DashboardProvider } from 'context/dashboard.context';
import PreviewProvider from 'context/previewContext';
import AuthGuard from 'utils/route-guard/AuthGuard';

const ApplicationPage = Loadable(lazy(() => import('features/applicationPage')));

// web routing
const MyApplicationPage = Loadable(lazy(() => import('features/dashboard/pages/MyApplication')));
const MyLicencePage = Loadable(lazy(() => import('features/dashboard/pages/MyLicence')));
const ConsentPage = Loadable(lazy(() => import('features/consent')));
const MyInfo = Loadable(lazy(() => import('features/myInfo/index')));
const CallbackRedirect = Loadable(lazy(() => import('features/myInfo/CallbackRed')));
const PreviewPage = Loadable(lazy(() => import('features/previewPage/index')));
const PaymentPage = Loadable(lazy(() => import('features/dashboard/pages/MyLicence/PaymentPage')));
const PendingPaymentsPage = Loadable(lazy(() => import('features/dashboard/pages/PendingPayments')));
const IndividualPaymentPage = Loadable(lazy(() => import('features/dashboard/pages/PendingPayments/IndividualPayment')));

// ==============================|| AUTH ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <Outlet />
        </AuthGuard>
    ),
    children: [
        {
            name: 'My Application Dashboard',
            path: '/my-applications',
            element: (
                <DashboardProvider>
                    <MyApplicationPage />
                </DashboardProvider>
            )
        },
        {
            name: 'My Licence Dashboard',
            path: '/my-licences',
            element: (
                <DashboardProvider>
                    <MyLicencePage />
                </DashboardProvider>
            )
        },
        {
            name: 'New Application: AEC',
            path: '/new-application/AEC',
            element: (
                <ApplicationProvider>
                    <ApplicationPage />
                </ApplicationProvider>
            )
        },
        {
            name: 'New Application: Video Games',
            path: '/new-application/VG',
            element: (
                <ApplicationProvider>
                    <ApplicationPage />
                </ApplicationProvider>
            )
        },

        {
            name: 'New Application: Declaration of Interactive Software',
            path: '/new-application/IS',
            element: (
                <ApplicationProvider>
                    <ApplicationPage />
                </ApplicationProvider>
            )
        },
        {
            name: 'New Application: PUB',
            path: '/new-application/PUB',
            element: (
                <ApplicationProvider>
                    <ApplicationPage />
                </ApplicationProvider>
            )
        },
        {
            name: 'New Application: PUB',
            path: '/my-applications/:case_id',
            element: (
                <PreviewProvider>
                    <PreviewPage />
                </PreviewProvider>
            )
        },
        {
            name: 'New Application: Films',
            path: '/new-application/FILMS',
            element: (
                <ApplicationProvider>
                    <ApplicationPage />
                </ApplicationProvider>
            )
        },
        {
            name: 'New Application: PUB',
            path: '/my-licences/:case_id',
            element: (
                <PreviewProvider>
                    <PreviewPage />
                </PreviewProvider>
            )
        },
        {
            name: 'New Licence: Payment',
            path: '/my-licences/payment/:case_id',
            element: (
                <DashboardProvider>
                    <PreviewProvider>
                        <PaymentPage />
                    </PreviewProvider>
                </DashboardProvider>
            )
        },
        {
            name: 'Navigate Dashboard',
            path: '/new-application',
            element: <Navigate to="/my-applications" />
        },
        {
            name: 'Consent Page',
            path: '/consent',
            element: <ConsentPage />
        },
        {
            name: 'myinfo',
            path: '/mi',
            element: <MyInfo />
        },
        {
            name: 'MyInfo',
            path: '/iris/api/mi/callback',
            element: <CallbackRedirect />
        },
        {
            name: 'Pending Payments',
            path: '/pending-payments',
            element: (
                <ApplicationProvider>
                    {/* <PreviewProvider> */}
                    <PendingPaymentsPage />
                    {/* </PreviewProvider> */}
                </ApplicationProvider>
            )
        },
        {
            name: 'Pending Payments',
            path: '/pending-payments/:case_id',
            element: (
                <ApplicationProvider>
                    <PreviewProvider>
                        <IndividualPaymentPage />
                    </PreviewProvider>
                </ApplicationProvider>
            )
        },
        {
            name: 'New Application: Radio Operator Exam',
            path: '/new-application/ROE',
            element: (
                <ApplicationProvider>
                    <ApplicationPage />
                </ApplicationProvider>
            )
        },
        {
            name: 'New Application: Accreditation of Certification Authority',
            path: '/new-application/ACA',
            element: (
                <ApplicationProvider>
                    <ApplicationPage />
                </ApplicationProvider>
            )
        },
        {
            name: 'Amend Application: Accreditation of Certification Authority',
            path: '/new-application/ACA-AMEND',
            element: (
                <ApplicationProvider>
                    <ApplicationPage />
                </ApplicationProvider>
            )
        },
        {
            name: 'Cancel Application: Accreditation of Certification Authority',
            path: '/new-application/ACA/cancel',
            element: (
                <ApplicationProvider>
                    <ApplicationPage />
                </ApplicationProvider>
            )
        },
        {
            name: 'Renew Application: Accreditation of Certification Authority',
            path: '/new-application/ACA-RENEW',
            element: (
                <ApplicationProvider>
                    <ApplicationPage />
                </ApplicationProvider>
            )
        },
        {
            name: 'New Application: Registration of Accounting Authority',
            path: '/new-application/AA',
            element: (
                <ApplicationProvider>
                    <ApplicationPage />
                </ApplicationProvider>
            )
        },
        {
            name: 'Cancel Application: Registration of Accounting Authority',
            path: '/new-application/AA/cancel',
            element: (
                <ApplicationProvider>
                    <ApplicationPage />
                </ApplicationProvider>
            )
        },
    ]
};

export default MainRoutes;
